import type { MusicOnHoldLocale } from './en'

export const musicOnHoldNe = {
  list: {
    title: `पकडमा संगीत`,
    loading: `प्लेलिस्टहरू लोड गर्दै...`,
    error: `त्रुटि`,
    empty: `कुनै प्लेलिस्ट फेला परेन`,
    emptyDescription: `यस पीबीएक्सको लागि हाल कुनै प्लेलिस्ट कन्फिगर गरिएको छैन।`,
    noResults: `कुनै परिणाम छैन`,
    noResultsDescription: `तपाईंको खोजसँग मिल्ने कुनै प्लेलिस्ट छैन।`,
    columnName: `नाम`,
    columnType: `प्रकार`,
    columnTracks: `ट्र्याकहरू`,
    columnUpdated: `अपडेट गरियो`,
    columnDefault: `पूर्वनिर्धारित`,
    columnPlayer: `पूर्वावलोकन`,
    noPreview: `अडियो छैन`,
    previewInDetail: `ट्र्याकहरू पूर्वावलोकन गर्न खोल्नुहोस्`,
    defaultDisabledTooltip: `पूर्वनिर्धारितको रूपमा सेट गर्न प्लेलिस्टमा कम्तीमा एक अडियो ट्र्याक वा स्ट्रिम URL हुनुपर्छ।`,
    defaultCurrentTooltip: `यो हालको पूर्वनिर्धारित प्लेलिस्ट हो।`,
    defaultSetTooltip: `पूर्वनिर्धारित प्लेलिस्टको रूपमा सेट गर्नुहोस्`,
    defaultBadge: `पूर्वनिर्धारित`,
    systemBadge: `सिस्टम`,
    notPlayableBadge: `बजाउन अयोग्य`,
    typeList: `सूची`,
    tracksLabel: `ट्र्याकहरू`,
    streaming: `स्ट्रिमिङ`,
    myPlaylists: `मेरा प्लेलिस्टहरू`,
    systemPlaylists: `सिस्टम प्लेलिस्टहरू`,
    searchPlaceholder: `प्लेलिस्टहरू खोज्नुहोस्...`,
    manageTracksButton: `अडियो ट्र्याकहरू`,
    createButton: `+ प्लेलिस्ट सिर्जना गर्नुहोस्`,
    createDisabledTooltip: `प्लेलिस्ट सिर्जना गर्न अहिले उपलब्ध छैन।`,
    columnActions: `कार्यहरू`,
    deleteAriaLabelNamed: `"{{name}}" प्लेलिस्ट मेटाउनुहोस्`,
    deleteConfirmTitle: `प्लेलिस्ट मेटाउने हो?`,
    deleteConfirmBody: `"{{name}}" मेटाउने हो? यो कार्य पूर्ववत गर्न सकिँदैन।`,
    deleteConfirm: `मेटाउनुहोस्`,
    deleteCancel: `रद्द गर्नुहोस्`,
    deleteDefaultWarning: `यो पूर्वनिर्धारित होल्ड-म्युजिक प्लेलिस्ट हो। यसलाई मेटाएमा सिस्टम पूर्वनिर्धारितमा फर्किन्छ।`,
  },
  detail: {
    loading: `प्लेलिस्ट लोड गर्दै...`,
    error: `त्रुटि`,
    notFound: `प्लेलिस्ट फेला परेन।`,
    backToList: `← सूचीमा फर्कनुहोस्`,
    editButton: `प्लेलिस्ट सम्पादन गर्नुहोस्`,
    editDisabledTooltip: `सम्पादन अहिले उपलब्ध छैन`,
    defaultBadge: `पूर्वनिर्धारित`,
    systemBadge: `सिस्टम`,
    generalTitle: `सामान्य जानकारी`,
    nameLabel: `नाम`,
    typeLabel: `प्रकार`,
    typeList: `सूची`,
    defaultLabel: `पूर्वनिर्धारित`,
    defaultYes: `हो`,
    defaultNo: `होइन`,
    activeLabel: `सक्रिय`,
    activeYes: `हो`,
    activeNo: `होइन`,
    idLabel: `ID`,
    uuidLabel: `UUID`,
    createdLabel: `सिर्जना गरियो`,
    updatedLabel: `अपडेट गरियो`,
    audioTracksTitle: `अडियो ट्र्याकहरू`,
    noAudioTracks: `यस प्लेलिस्टसँग सम्बन्धित कुनै अडियो ट्र्याक छैन।`,
    manageTracksButton: `ट्र्याकहरू व्यवस्थापन गर्नुहोस्`,
  },
  audioTracks: {
    title: `अडियो ट्र्याकहरू`,
    loading: `अडियो ट्र्याकहरू लोड गर्दै...`,
    empty: `यस पीबीएक्सको लागि कुनै अडियो ट्र्याक अपलोड गरिएको छैन।`,
    columnName: `नाम`,
    columnFile: `फाइल`,
    uploadButton: `संगीत अपलोड गर्नुहोस्`,
    close: `बन्द गर्नुहोस्`,
    nameLabel: `ट्र्याक नाम`,
    namePlaceholder: `ट्र्याक नाम प्रविष्ट गर्नुहोस्`,
    nameRequired: `कृपया ट्र्याकको लागि नाम प्रविष्ट गर्नुहोस्।`,
    audioFileRequired: `कृपया एउटा अडियो फाइल छान्नुहोस्।`,
    fileTypeInvalid: `केवल WAV वा MP3 फाइलहरू मात्र समर्थित छन्।`,
    fileSizeExceeded: `फाइलले २५ MB सीमा नाघेको छ ({{size}} MB)।`,
    dropzonePlaceholder: `WAV वा MP3 फाइल यहाँ तान्नुहोस् वा ब्राउज गर्न क्लिक गर्नुहोस्`,
    dropzoneAccepted: `WAV, MP3 (अधिकतम २५ MB)`,
    removeFile: `हटाउनुहोस्`,
    cancel: `रद्द गर्नुहोस्`,
    uploadSubmit: `अपलोड गर्नुहोस्`,
    uploading: `अपलोड गर्दै...`,
    uploadFailed: `अपलोड असफल भयो`,
    deleteConfirmTitle: `अडियो ट्र्याक मेटाउने हो?`,
    deleteConfirmBody: `"{{name}}" मेटाउने हो? यो कार्य पूर्ववत गर्न सकिँदैन।`,
    deleteConfirm: `मेटाउनुहोस्`,
    deleteFailed: `मेटाउन असफल भयो`,
    deleteAriaLabel: `अडियो ट्र्याक मेटाउनुहोस्`,
  },
  createModal: {
    title: `नयाँ प्लेलिस्ट`,
    nameLabel: `नाम`,
    namePlaceholder: `प्लेलिस्टको नाम प्रविष्ट गर्नुहोस्`,
    cancel: `बन्द गर्नुहोस्`,
    submit: `प्लेलिस्ट सिर्जना गर्नुहोस्`,
  },
  editModal: {
    title: `प्लेलिस्ट सम्पादन गर्नुहोस्`,
    nameLabel: `नाम`,
    namePlaceholder: `प्लेलिस्टको नाम प्रविष्ट गर्नुहोस्`,
    cancel: `रद्द गर्नुहोस्`,
    submit: `परिवर्तनहरू सुरक्षित गर्नुहोस्`,
    error: `प्लेलिस्ट सुरक्षित गर्न असफल भयो`,
  },
  manageTracks: {
    title: `ट्र्याकहरू व्यवस्थापन गर्नुहोस्`,
    inPlaylistTitle: `यस प्लेलिस्टमा`,
    availableTitle: `उपलब्ध ट्र्याकहरू`,
    noneAssigned: `यस प्लेलिस्टमा अहिलेसम्म कुनै ट्र्याक थपिएको छैन।`,
    noTracksUploaded: `यस पीबीएक्सको लागि कुनै अडियो ट्र्याक अपलोड गरिएको छैन।`,
    allAdded: `सबै उपलब्ध ट्र्याकहरू पहिले नै यस प्लेलिस्टमा छन्।`,
    add: `थप्नुहोस्`,
    remove: `हटाउनुहोस्`,
    done: `सम्पन्न भयो`,
    addFailed: `ट्र्याक थप्न असफल भयो`,
    removeFailed: `ट्र्याक हटाउन असफल भयो`,
  },
  trackPlay: {
    play: `बजाउनुहोस्`,
    loading: `लोड हुँदै…`,
    error: `पूर्वावलोकन उपलब्ध छैन`,
    close: `पूर्वावलोकन बन्द गर्नुहोस्`,
  },
  pagination: {
    resultsPerPage: `पृष्ठमा परिणामहरू:`,
    previousPage: `अघिल्लो पृष्ठ`,
    nextPage: `अर्को पृष्ठ`,
    jumpToPage: `{{page}} पृष्ठमा जानुहोस्`,
    all: `सबै`,
  },
} satisfies MusicOnHoldLocale
